/** Raised after a mint attempt so the Registers tab badge re-reads the pending count. */
export const PENDING_ACCRUED_UNITS_CHANGED = "pending-accrued-units-changed";

export const announcePendingAccruedUnitsChanged = (): void => {
  window.dispatchEvent(new Event(PENDING_ACCRUED_UNITS_CHANGED));
};
